import React, { useState } from "react";
import { Button, Grid } from "@material-ui/core";
import {
  facebook,
  instagram,
  twitter,
  linkedin,
  planefill,
} from "../../../resources/images/index";
import {
  LogHeader,
  MainHeading,
  InnerHeader,
} from "../../../components/common/Header/index";

import Cards from "../../../components/common/Cards";

const data = [
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "September 1, 2020",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "September 1, 2020",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "September 1, 2020",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "September 1, 2020",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "September 1, 2020",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "September 1, 2020",
    time: "10 AM PST",
  },
];

function LogUpcomingEvents(props) {
  return (
    <div className="latestReleaseDetailWrapper allCategory">
      <LogHeader />
      <MainHeading headerSubHeading="All Upcoming Events">
        <div className="popupBody">
          <div className="cards">
            <Grid container spacing={3}>
              {data.map((item, index) => (
                <Grid key={index} item md={4}>
                  <Cards
                    picture={item.picture}
                    subheading={item.subheading}
                    cardtext={item.cardtext}
                    time={item.time}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      </MainHeading>
    </div>
  );
}

export default LogUpcomingEvents;
